import { useState } from "react";

export default function FloatingWhatsApp() {
  const [open, setOpen] = useState(false);

  const waLink = "https://wa.me/443335775445?text=Hi%20Cleario%21%20I%27d%20like%20an%20instant%20quote.%20Here%20are%20the%20details%20of%20my%20items%3A";

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col items-start gap-3">
      {/* Popup card */}
      <div
        className={`transition-all duration-300 origin-bottom-left ${
          open
            ? "opacity-100 translate-y-0 scale-100 pointer-events-auto"
            : "opacity-0 translate-y-4 scale-95 pointer-events-none"
        }`}
      >
        <div className="bg-white rounded-2xl p-5 w-72 relative"
          style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.14)", border: "2px solid #e2e8f0" }}>
          {/* Close */}
          <button
            onClick={() => setOpen(false)}
            className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer text-gray-400 text-xs"
          >
            <i className="ri-close-line"></i>
          </button>

          {/* Header */}
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#25D366] flex-shrink-0">
              <i className="ri-whatsapp-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-cl-dark font-black text-sm leading-none">Cleario</p>
              <p className="text-[#25D366] text-xs font-semibold mt-0.5 flex items-center gap-1">
                <span className="w-2 h-2 rounded-full bg-[#25D366] inline-block"></span>
                Typically replies quickly
              </p>
            </div>
          </div>

          {/* Message bubble */}
          <div className="bg-[#f0fdf4] rounded-2xl rounded-tl-sm px-4 py-3 mb-4">
            <p className="text-cl-dark text-sm font-semibold leading-relaxed">
              Want an instant quote? Send us a WhatsApp message with a photo or details of your items.
            </p>
          </div>

          <a
            href={waLink}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-black text-sm px-5 py-3 rounded-xl w-full whitespace-nowrap cursor-pointer hover:bg-[#1fbb5a] transition-colors"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Start WhatsApp chat
          </a>
        </div>
        {/* Arrow pointing down-left toward button */}
        <div className="ml-5 w-4 h-3 overflow-hidden">
          <div
            className="w-4 h-4 bg-white rotate-45 -mt-2 ml-1"
            style={{ border: "2px solid #e2e8f0", borderTop: "none", borderLeft: "none" }}
          ></div>
        </div>
      </div>

      {/* Floating button */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="relative w-14 h-14 flex items-center justify-center rounded-full text-white cursor-pointer transition-transform hover:scale-110 active:scale-95"
        style={{
          background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
          boxShadow: "0 4px 20px rgba(37,211,102,0.45)",
        }}
        aria-label="Chat on WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
        {/* Pulse ring */}
        <span
          className="absolute inset-0 rounded-full animate-ping"
          style={{ background: "rgba(37,211,102,0.3)" }}
        ></span>
      </button>
    </div>
  );
}
